export { Favorites, useFavorites } from './ui/Favorites';
export { favoritesReducer, addToFavoriteThunk, removeFromFavoritesThunk } from './model/slice/favoritesSlice';
